import script from "./SupplierManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./SupplierManagement.vue?vue&type=script&setup=true&lang=js"

import "./SupplierManagement.vue?vue&type=style&index=0&id=27642d8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27642d8c"]])

export default __exports__